import { Link } from 'react-router-dom'

import styles from '@/pages/PortalPages.module.css'

type AdminHeaderActionsProps = {
  logout: () => void
}

/**
 * Shared admin page actions — same buttons/order on every admin list page.
 */
export function AdminHeaderActions({ logout }: AdminHeaderActionsProps) {
  return (
    <div className={styles.actions}>
      <Link className={styles.secondary} to="/admin">
        <span className={styles.btnIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M4 19V7.5A2.5 2.5 0 0 1 6.5 5H14l6 5.5V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z" />
            <path d="M14 5v5h6" />
            <path d="M8 13h8M8 16h5" />
          </svg>
        </span>
        Applications
      </Link>
      <Link className={styles.secondary} to="/admin/vendors">
        <span className={styles.btnIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z" />
            <path d="M8 12a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z" />
            <path d="M8 14c-2.8 0-5 1.6-5 3.5V19h10v-1.5C13 15.6 10.8 14 8 14Z" />
            <path d="M16 14c-.4 0-.8 0-1.2.1 1.5.8 2.2 2 2.2 3.4V19H21v-1.5c0-1.9-2.2-3.5-5-3.5Z" />
          </svg>
        </span>
        Vendors
      </Link>
      <Link className={styles.secondary} to="/admin/admins">
        <span className={styles.btnIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 12a3.5 3.5 0 1 0-3.5-3.5A3.5 3.5 0 0 0 12 12Z" />
            <path d="M5 19c0-3.3 3.1-5 7-5s7 1.7 7 5" />
            <path d="M17.5 8.5 19 10l2.5-2.5" />
          </svg>
        </span>
        Admins
      </Link>
      <Link className={styles.secondary} to="/admin/events">
        <span className={styles.btnIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="4" y="5" width="16" height="15" rx="2" />
            <path d="M8 3v4M16 3v4M4 10h16" />
            <path d="M8 14h2M12 14h2M16 14h.01M8 17h2M12 17h2" />
          </svg>
        </span>
        Calendar
      </Link>
      <Link className={styles.secondary} to="/profile">
        Profile
      </Link>
      <button type="button" className={styles.ghost} onClick={logout}>
        <span className={styles.btnIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4" />
            <path d="M14 12H8" />
            <path d="m16 8 4 4-4 4" />
          </svg>
        </span>
        Sign out
      </button>
    </div>
  )
}
